import { render, staticRenderFns } from "./AreaVisitReport.vue?vue&type=template&id=520ed785&"
import script from "./AreaVisitReport.vue?vue&type=script&lang=js&"
export * from "./AreaVisitReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports